import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyBrandTheme } from "./lib/brand";

// Iframe-breakout. The B2C signup journey runs inside the parent SPA's modal
// <iframe>; after the adapter's /auth/callback 302s here, the iframe lands on
// online.<root>/?transactionId=…. Without this guard we'd render the
// dashboard *inside* that iframe at onboarding.<root> — the
// __Host-mf_session cookie the callback just set is host-locked to
// online.<root>, so it'd be invisible to the parent tab. The parent SPA
// would have no way of knowing signup succeeded.
//
// Fix: when this SPA detects it's framed, navigate the outermost frame to
// the same URL it's loaded at. The parent's iframe element has
// `sandbox="… allow-top-navigation …"` so this is legal cross-origin.
// `location.replace` skips a history entry — the iframe is about to be
// detached anyway. React mount is skipped: nothing to render in a frame
// that's about to die.
if (window.self !== window.top && window.top) {
  window.top.location.replace(window.location.href);
} else {
  applyBrandTheme(); // brand-tint the surface (buttons/avatar) before first paint

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: false, refetchOnWindowFocus: false },
    },
  });

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("missing #root in index.html");

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}
